<template>
    <section class="relative overflow-hidden h-[80vh] big-img-slider will-change" :data-scroll-section="inner == 'false'">


        <div class="absolute  w-[calc(100%-16.6vw)] xl:w-auto text-center xl:text-left top-4 xl:top-10 2xl:top-20 left-1/2 -translate-x-1/2 xl:translate-x-0 xl:left-0 xl:pl-[15vw] tracking-desk text-sm leading-5 uppercase text-white z-20" v-show="blockData.kicker">{{ blockData.kicker }}</div>

        <div class="flex flex-col xl:flex-row justify-center xl:justify-end items-center  xl:pr-[15vw] absolute left-0 xl:left-auto xl:right-0 bottom-4 xl:bottom-auto xl:top-7 2xl:top-20 w-full xl:w-auto z-20">
            <div class="hidden md:block text-lg md:text-2xl font-canela font-light text-white mb-3 xl:mb-0 xl:mr-5 tracking-[1px]">{{ activeSlideIndex+1 }} / {{ blockData.slides.length }}</div>
            <!-- <div class="swiper-pagination-dots"></div> -->
            <div class="dots">
                <div v-show="blockData.slides" class="dot" v-for="(item, index) in blockData.slides" :class="{'active' : index == activeSlideIndex}" :key="'dot-' + index">
                    <progress-ring v-show="index == activeSlideIndex"  stroke="2" radius="20" :progress="(100 / blockData.slides.length) * (activeSlideIndex+1)"></progress-ring>
                </div>
            </div>
        </div>


        <div class="swiper-container h-full" ref="slider">

            <div class="swiper-wrapper">
                <div v-for="( slide, index ) in blockData.slides" :key="index" class="swiper-slide relative after:block after:absolute after:w-full after:h-full after:bg-black after:opacity-40 after:top-0 after:left-0">
                        <img class="object-cover w-full h-full" v-show="slide.image" :src="slide.image.url" :alt="slide.image.alt">
                    <div class="absolute top-0 left-0 text-white w-full h-full px-content xl:px-[15vw] flex flex-col justify-center z-10">
                        <h3 class="text-4xl xl:text-title 2xl:text-[96px] leading-none tracking-[2px] text-white text-center xl:text-left xl:max-w-[40vw] mb-5" v-show="slide.title" v-html="slide.title"></h3>
                        <p class="xl:max-w-[40vw] leading-normal text-center xl:text-left"  v-show="slide.text" v-html="slide.text"></p>
                        <a v-if="slide.cta" :href="slide.cta.url" class="btn btn-clean self-center xl:self-start">
                            {{slide.cta.title}}
                            <svg class="ml-6" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 12L21 12" stroke="#ffffff" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round" />
                                <path d="M18 8L22 12L18 16" stroke="#ffffff" stroke-width="1.2" stroke-linecap="square" />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- controls -->
        <div class="controls hidden xl:flex items-center justify-between w-full absolute top-1/2 left-0 z-30 px-desk -translate-y-1/2">
            <div class="control-left mr-7">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="29.5" stroke="white"/>
                    <path d="M40 30L21 30" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                    <path d="M24 34L20 30L24 26" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                </svg>
            </div>

            <div class="control-right ml-7">
                <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="30" cy="30" r="29.5" stroke="white"/>
                    <path d="M20 30L39 30" stroke="white" stroke-width="1.2" stroke-linecap="square" stroke-linejoin="round"/>
                    <path d="M36 26L40 30L36 34" stroke="white" stroke-width="1.2" stroke-linecap="square"/>
                </svg>
            </div>
        </div>
        <!-- ./controls -->


    </section>
</template>


<script>
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
    export default {
        name: 'BigImageSlider',
        data() {
            return {
                slider: null,
                sliderOptions: {
                    // autoplay: {
                    //     delay: 3500,
                    // },
                    slidesPerView: 1,
                    spaceBetween: 15,
                    speed: 2000,
                    loop: true,
                    /* freeMode: true, */
                    breakpoints: {
                        320: {
                            slidesPerView: 1,
                            spaceBetween: 16,
                            navigation: false
                        },
                        768: {
                            slidesPerView: 1,
                            spaceBetween: 16,
                            navigation: {
                                prevEl: '.controls .control-left',
                                nextEl: '.controls .control-right',
                            },
                            pagination: {
                                el: ".dot",
                            },
                        }
                    }
                },

                slidesLength: false,
                activeSlideIndex: 0
            }
        },
        mounted() {
            this.slider = new Swiper( this.$refs.slider, this.sliderOptions );
            var self = this
            this.slider.on('slideChange', function () {
                self.activeSlideIndex = self.slider.realIndex
            });
            this.slidesLength = this.slider.slides.length
        },
        methods: {},
        computed: {}
    }
</script>

<style>
  .custom-easing-1 {
    --xyz-ease: cubic-bezier(0,.83,0,1);
  }
</style>
